import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';

import { TimePicker, DatePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Switch from '@material-ui/core/Switch';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';

import Search from '../Common/Search/Search';
import ModalBox from '../Common/Modals/ModalBox';
import {isNullOrEmpty, roundTime} from '../Common/helpers';
import AppointmentsTable from './AppointmentsTable';

import './style.css';

import { API } from '../../ws/constants';

var moment = require('moment');

function readViewPreferences(key) {
    try {
        const saved = JSON.parse(localStorage.getItem(key));
        if (!saved || typeof saved !== 'object') return {};
        const preferences = {};
        if (Array.isArray(saved.staffFilter) && saved.staffFilter.length && saved.staffFilter.every(id => typeof id === 'string')) {
            preferences.staffFilter = saved.staffFilter.includes('dateView') ? ['dateView'] : saved.staffFilter;
        }
        if (Array.isArray(saved.storeFilter) && saved.storeFilter.length && saved.storeFilter.every(id => typeof id === 'string')) preferences.storeFilter = saved.storeFilter;
        if ([15,30].includes(saved.rowsPerPage)) preferences.rowsPerPage = saved.rowsPerPage;
        if (typeof saved.filterByHour === 'boolean') preferences.filterByHour = saved.filterByHour && (!preferences.staffFilter || preferences.staffFilter[0] === 'dateView');
        return preferences;
    } catch (error) { return {}; }
}

class Appointments extends Component {
    constructor(props) {
        const date = moment();
        super(props);
        this.viewStorageKey = 'schedulapp.appointments.view.' + this.props.loginData.Id;
        const preferences = readViewPreferences(this.viewStorageKey);

        this.state = {
            fetchData:null
            ,fetchStores:null
            ,fetchStaff:null
            ,tableLoading:false
            ,openModal:false
            ,hasFixedHeader:false
            ,loginLevel:this.props.loginData.AccessLevel
            ,filterByHour: false
            ,rowsPerPage: !isNullOrEmpty(sessionStorage.getItem("appointmentsRowsPerPage")) ? parseInt(sessionStorage.getItem("appointmentsRowsPerPage"), 10) : 30
            ,storeFilter: !isNullOrEmpty(sessionStorage.getItem("storeFilter")) ? sessionStorage.getItem("storeFilter").split(",") : [""]
            ,dateFilter: !isNullOrEmpty(sessionStorage.getItem("dateFilter")) ? sessionStorage.getItem("dateFilter") : date.format('YYYY-MM-DD')
            ,timeFilterStart: !isNullOrEmpty(sessionStorage.getItem("timeFilterStart")) ? sessionStorage.getItem("timeFilterStart") : date
            ,timeFilterEnd: !isNullOrEmpty(sessionStorage.getItem("timeFilterEnd")) ? sessionStorage.getItem("timeFilterEnd") : date
            ,dateName: "Hoje"
            ,staffFilter: ["dateView"]
            ,staffObj: [""]
            ,...preferences
        };
        this.toggleIsTrue = this.state.filterByHour;
    }

    saveViewPreferences = (changes = {}) => {
        const {staffFilter, storeFilter, rowsPerPage, filterByHour} = {...this.state, ...changes};
        try {
            localStorage.setItem(this.viewStorageKey, JSON.stringify({
                staffFilter: staffFilter.map(String), storeFilter: storeFilter.map(String), rowsPerPage,
                filterByHour: !!filterByHour && staffFilter[0] === 'dateView'
            }));
        } catch (error) { /* Keep the page usable if browser storage is unavailable. */ }
    }

    componentWillMount() {
        const { timeFilterStart, timeFilterEnd, dateFilter, storeFilter } = this.state;

        Promise.all([
            fetch(API + "getstaff&getbystoreid="+this.state.storeFilter+"&getbydate="+this.state.dateFilter+"&onlyactive=true")
            ,fetch(API + "getstores")
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            const staffConfirmation = this.confirmStaff(data[0].data);

            this.getAppointmentsByDateAndStaff({
                dateFilter
                , timeFilterStart
                , timeFilterEnd
                , storeFilter
                , dateName: dateFilter === moment().format('YYYY-MM-DD') ? 'Hoje' : dateFilter
                , staffFilter: staffConfirmation.staffFilter
                , staffObj: staffConfirmation.finalStaffObj
                , fetchStaff: data[0].data
                , fetchStores: data[1].data
            });
        });
    }

    getStaffInfo = (staff, fetchedStaff) => {
        let thisNames = [];
        const fetchStaff = typeof fetchedStaff !== 'undefined' ? fetchedStaff : this.state.fetchStaff;
        staff = typeof staff !== 'undefined' ? staff : this.state.staffFilter;

        for(var i=0,n=fetchStaff.length;i<n;i++){
            for(var s=0,m=staff.length;s<m;s++){
                if(String(fetchStaff[i].Id) === String(staff[s]))
                    thisNames.push({StaffId: fetchStaff[i].Id, StaffName: fetchStaff[i].FirstName + " " +fetchStaff[i].LastName});
            }
        }
        return thisNames.length === 0 ? [""] : thisNames;
    }

    handleSearch = (search) => {
        this.setState({tableLoading:true});
        fetch(API + "searchappointments&getbydate=" + this.state.dateFilter + "&keyword=" + search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleToggleTimeFilter = (e, value) => {
        const { dateFilter, storeFilter, dateName } = this.state;
        const currentTime = roundTime(moment(), moment.duration(15, "minutes"), "round");
        const timeStart = sessionStorage.getItem("timeFilterStart") ? moment(sessionStorage.getItem("timeFilterStart")) : currentTime;
        const timeEnd = sessionStorage.getItem("timeFilterEnd") ? moment(sessionStorage.getItem("timeFilterEnd")) : currentTime;

        this.setState({ filterByHour: value });
        this.toggleIsTrue = value;

        sessionStorage.setItem("timeFilterStart", timeStart);
        sessionStorage.setItem("timeFilterEnd", timeEnd);

        this.getAppointmentsByDateAndStaff({
            dateFilter
            , storeFilter
            , dateName
            , staffObj: [""]
            , staffFilter: ["dateView"]
            , timeFilterStart: timeStart
            , timeFilterEnd: timeEnd
            , filterByHour: value
        });
    };

    handleTimeFilterChangeStart = (value) => {
        const { timeFilterEnd, dateFilter, staffFilter, storeFilter, staffObj, dateName } = this.state;
        const filterEnd = timeFilterEnd ? moment(timeFilterEnd) : moment();

        sessionStorage.setItem("timeFilterStart", moment(value));

        value = value > filterEnd ? roundTime(filterEnd, moment.duration(15, "minutes"), "round") : roundTime(value, moment.duration(15, "minutes"), "round");
        
        this.setState({tableLoading:true});

        this.getAppointmentsByDateAndStaff({
            dateFilter
            , timeFilterEnd
            , staffFilter
            , storeFilter
            , staffObj
            , dateName
            , timeFilterStart: value
        });
    }

    handleTimeFilterChangeEnd = (value) => {
        const { timeFilterStart, dateFilter, staffFilter, storeFilter, staffObj, dateName } = this.state;
        const filterStart = moment(timeFilterStart);

        sessionStorage.setItem("timeFilterEnd", moment(value));

        value = value < filterStart ? roundTime(filterStart, moment.duration(15, "minutes"), "round") : roundTime(value, moment.duration(15, "minutes"), "round");
        
        this.setState({tableLoading:true});

        this.getAppointmentsByDateAndStaff({
            dateFilter
            , timeFilterStart
            , staffFilter
            , storeFilter
            , staffObj
            , dateName
            , timeFilterEnd: value
        });
    }

    handleStaffViewChange = (e, item) => {
        const { filterByHour, timeFilterStart, timeFilterEnd, dateFilter, storeFilter, dateName } = this.state;
        let value = e.target.value;

        if(item.props.value==="dateView"){
            value = ["dateView"];
        }else{
            if (value.length > 1 && value.indexOf("dateView") > -1){
                value.splice(value.indexOf("dateView"), 1);
            }

            if(!value.length){
                value = ["dateView"];
            }

            this.setState({ filterByHour: false });
            this.toggleIsTrue = false;
        }
        let staffObjVal = this.getStaffInfo(value);


        this.getAppointmentsByDateAndStaff({
            dateFilter
            , storeFilter
            , dateName
            , timeFilterStart: filterByHour ? timeFilterStart : ""
            , timeFilterEnd: filterByHour ? timeFilterEnd : ""
            , staffFilter: value
            , staffObj: staffObjVal
            , filterByHour: value[0] === 'dateView' && filterByHour
        });
    }

    handleDateFilterChange = (value) => {
        const { filterByHour, timeFilterStart, timeFilterEnd, storeFilter } = this.state;

        sessionStorage.setItem("dateFilter", value.format('YYYY-MM-DD'));

        value = value.format('YYYY-MM-DD');        

        // get staff based on their store and schedule for the day
        fetch(API + "getstaff&getbystoreid=" + storeFilter + "&getbydate=" + value)
        .then(response => response.json())
        .then(result => {
            const staffConfirmation = this.confirmStaff(result.data);
            this.getAppointmentsByDateAndStaff({
                dateFilter: value
                , timeFilterStart: filterByHour ? timeFilterStart : ""
                , timeFilterEnd: filterByHour ? timeFilterEnd : ""
                , storeFilter
                , dateName: new Date(value).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0) ? "Hoje" : value
                , fetchStaff: result.data
                , staffFilter: staffConfirmation.staffFilter
                , staffObj: staffConfirmation.finalStaffObj
            });
        });
    }

    handleStoreChange = (e, item) => {
        const { filterByHour, timeFilterStart, timeFilterEnd, dateFilter, dateName } = this.state;
        let value = e.target.value;
        if(item.props.value===""){
            value=[""];
        }else{
            if (value.length > 1 && value.indexOf("") > -1)
                value.splice(value.indexOf(""), 1);

            if(!value.length)
                value = [""];
        }

        sessionStorage.setItem("storeFilter", value);

        // get staff based on their store and schedule for the day
        fetch(API + "getstaff&getbystoreid=" + value + "&getbydate=" + dateFilter)
        .then(response => response.json())
        .then(result => {
            const staffConfirmation = this.confirmStaff(result.data);
            this.getAppointmentsByDateAndStaff({
                dateFilter
                , dateName
                , timeFilterStart: filterByHour ? timeFilterStart : ""
                , timeFilterEnd: filterByHour ? timeFilterEnd : ""
                , storeFilter: value
                , fetchStaff: result.data
                , staffFilter: staffConfirmation.staffFilter
                , staffObj: staffConfirmation.finalStaffObj
            });
        });
    }

    handleChangeRowsPerPage = pages => {
        sessionStorage.setItem("appointmentsRowsPerPage", pages);
        this.saveViewPreferences({rowsPerPage: Number(pages)});
        this.setState({ rowsPerPage: pages });
    };

    confirmStaff = (data) => {
        const finalStaffObj = [];
        let staffFilter = [...this.state.staffFilter];

        for(var i=0,n=data.length;i<n;i++){
            const id = data[i].Id;
            for(var j=0,m=staffFilter.length;j<m;j++){
                if(String(id)===String(staffFilter[j])){
                    finalStaffObj.push({StaffId:id, StaffName:data[i].FullName});
                    break;
                }
            }
        }

        if(finalStaffObj.length === 0){
            finalStaffObj.push("");
            staffFilter = ["dateView"];
        }

        if (finalStaffObj[0] !== '') staffFilter = finalStaffObj.map(staff => String(staff.StaffId));

        return {finalStaffObj, staffFilter};
    }

    deleteRow = (appointmentId) => {
        if(window.confirm("Tem a certeza que quer apagar esta marcação?")){
            this.setState({tableLoading:true});
            fetch(API + 'deleteappointment&appointmentid=' + appointmentId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
            });
        }
    }

    getAppointmentsByDateAndStaff = (obj) => {; // TODO scrap this shit!
        if(!obj && this.lastSentObj){
            obj = this.lastSentObj;
        }
        const staffFilter = obj.staffFilter !== null && obj.staffFilter.length >= 1 && obj.staffFilter[0] !== "dateView" ? "&getbystaffid=" + obj.staffFilter : ""
            , storeFilter = obj.storeFilter !== null && obj.storeFilter.length >= 1 && obj.storeFilter[0] !== "" ? "&getbystoreid=" + obj.storeFilter.join(",") : ""
            , timeFilter = this.toggleIsTrue && !!obj.timeFilterStart && !!obj.timeFilterEnd ? "&getbytime=" + [moment(obj.timeFilterStart).format("HH:mm:00"), moment(obj.timeFilterEnd).format("HH:mm:00")] : "";

        this.saveViewPreferences(obj);
        const requestId = this.appointmentsRequestId = (this.appointmentsRequestId || 0) + 1;
        this.setState({tableLoading:true, fetchData:null, ...obj});
        return fetch(API + "searchappointments&getbydate=" + obj.dateFilter + staffFilter + storeFilter + timeFilter)
        .then(response => response.json())
        .then(result => {
            if (requestId !== this.appointmentsRequestId) return;
            if (!result || result.shortmsg === 'NOK' || !result.data) throw new Error(result && result.message ? result.message : 'Não foi possível carregar as marcações.');
            this.lastSentObj = obj;
            this.setState({ fetchData: result.data.data ? result.data.data : result, tableLoading:false, ...obj })
        }).catch(error => {
            if (requestId !== this.appointmentsRequestId) return;
            this.setState({tableLoading:false, fetchData:null, openModal:true,
                returnTitle:'Erro', returnText:error.message});
        });
    }

    renderStaffOptions = (e) => {
        const staff = this.state.fetchStaff;
        if(staff===null)
            return;

        const items = [<MenuItem value="dateView" key="0">Vista por Data</MenuItem>];
        for (let i=0,n=staff.length;i<n;i++) {
            items.push(<MenuItem value={staff[i].Id}
                                 checked={this.state.staffFilter && this.state.staffFilter.indexOf(staff[i].Id) > -1}
                                 className="insetItem"
                                 key={staff[i].Id}>{staff[i].StaffId + " - " + staff[i].FirstName + " " + staff[i].LastName}</MenuItem>);
        }
        return items;
    }

    renderStoresOptions = (e) => {
        const stores = this.state.fetchStores;
        if(stores===null)
            return;

        const items = [<MenuItem value="" key="0">Todas as Lojas</MenuItem>];
        for (let i=0,n=stores.length;i<n;i++) {
            items.push(<MenuItem value={stores[i].Id}
                                 key={stores[i].Id}
                                 checked={this.state.storeFilter && this.state.storeFilter.indexOf(stores[i].Id) > -1}
                                 className="insetItem">{stores[i].Name + " - " + stores[i].Shortname}</MenuItem>);
        }
        return items;
    }

    clearFilters = () => {
        const date = moment();
        const resetObj = {
            filterByHour: false
            ,storeFilter: [""]
            ,dateFilter: date.format('YYYY-MM-DD')
            ,timeFilterStart: null
            ,timeFilterEnd: null
            ,staffFilter:["dateView"]
            ,dateName: "Hoje"
            ,staffObj: [""]
        };
        sessionStorage.setItem("storeFilter", "");
        sessionStorage.setItem("staffFilter", "");
        sessionStorage.setItem("dateFilter", "");
        sessionStorage.setItem("timeFilterStart", "");
        sessionStorage.setItem("timeFilterEnd", "");
        this.toggleIsTrue = false;

        this.setState(resetObj, this.getAppointmentsByDateAndStaff(resetObj));
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        //this.props.props.history.push('/Appointments');
        window.location.reload();
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const optsStaff = this.renderStaffOptions()
              , optsStores = this.renderStoresOptions()
              , appointments = this.state.fetchData != null ? this.state.fetchData.data : null
              , staffObj = this.state.staffObj
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : "";

        let tableInfo = [];
        if(appointments !== null && staffObj !== null && staffObj.length > 0 && staffObj[0] !== ""){
            for(let i=0,n=staffObj.length;i<n;i++){
                tableInfo.push({
                    key: "staff_" + staffObj[i].StaffId
                    , dateName: this.state.dateName
                    , staffId:staffObj[i].StaffId
                    , staffName: staffObj[i].StaffName + " - "
                    , appointmentData: appointments["sId_"+staffObj[i].StaffId] || []
                });
            }
        }else{
            tableInfo.push({
                key: "staff_0"
                , dateName: this.state.dateName
                , staffName: ""
                , appointmentData: appointments
            });
        }

        return (
            <div id="appointmentsPage" ref="page" className={this.state.staffFilter[0] !== 'dateView' ? 'staffLookup' : ''}>
                <div className="row">
                    <Search searchCallback={this.handleSearch}
                            fullWidth={true}
                            className={"col-12 col-md-4" + (this.state.staffFilter[0] === "dateView" ? "" : " hidden")} />
                </div>
                <div className="pageHeader">
                    <h1>
                        <i className="fa fa-book"></i> Marcações 
                        {(isAdmin || loginData.profile.Appointments.ADD) && 
                            <span className="float-right">
                                <Tooltip
                                    title={"Adicionar Marcação"}
                                    enterDelay={200}> 
                                    <span><NavLink className="actionButton success" to={{pathname: "/Appointments/New", appDate: this.state.dateFilter}}><i className="fa fa-plus"></i></NavLink></span>
                                </Tooltip>
                            </span>
                        }
                    </h1>
                </div>
                <div className="row">
                    <div className="col-12 col-md-4 buttonsHolder smallMarginTop">
                        <Button onClick={() => this.clearFilters()} className="defaultButton clearFilters" variant="contained" title="Limpa os filtros"><i className='fa fa-eraser'></i> Limpar filtros</Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div className="fieldHolder selectField">
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor="storesFilter">Escolha uma clínica</InputLabel>
                                <Select id="storesFilter"
                                        name="storesFilter"
                                        value={this.state.storeFilter}
                                        onChange={this.handleStoreChange}
                                        multiple
                                        data-empty-error-message="Este campo não pode estar vazio">
                                  {optsStores}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="fieldHolder selectField">
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor="staffFilter">Vista por funcionários</InputLabel>
                                <Select id="staffFilter"
                                        name="staffFilter"
                                        value={this.state.staffFilter}
                                        onChange={this.handleStaffViewChange}
                                        multiple
                                        data-empty-error-message="Este campo não pode estar vazio">
                                  {optsStaff}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="fieldHolder col-12 col-md-2">
                        <DatePicker
                            fullWidth={true}
                            id="dateFilter"
                            name="dateFilter"
                            placeholder="Ver dia"
                            label="Ver dia"
                            format="DD/MM/YYYY"
                            value={this.state.dateFilter || ""}
                            locale="pt-PT"
                            onChange={this.handleDateFilterChange}
                        />
                    </div>
                    <div className={"fieldHolder hoursFilter col-12 col-md-2" + (!this.state.filterByHour ? " noHours" : "")}>
                    <FormControlLabel
                        className="smallerToggle"
                        control={
                            <Switch
                                id="filterByHour"
                                checked={!!+this.state.filterByHour}
                                onChange={this.handleToggleTimeFilter}
                                color="primary"/>
                        }
                        label="Filtrar hora"/>
                        <TimePicker
                            id="timeFilterStart"
                            name="timeFilterStart"
                            label="Início"
                            value={this.state.timeFilterStart}
                            onChange={this.handleTimeFilterChangeStart}
                            ampm={false}
                            minutesStep={15}
                            format="HH:mm"
                            disabled={!this.state.filterByHour} />
                        <TimePicker
                            id="timeFilterEnd"
                            name="timeFilterEnd"
                            label="Fim"
                            value={this.state.timeFilterEnd}
                            onChange={this.handleTimeFilterChangeEnd}
                            ampm={false}
                            minutesStep={15}
                            format="HH:mm"
                            disabled={!this.state.filterByHour} />
                    </div>
                </div>
                <div className={"flexHolder" + loadingClass}>
                    {tableInfo.map(table =>
                        <AppointmentsTable key={table.key}
                                           rowsPerPage={this.state.rowsPerPage}
                                           dateName={table.dateName}
                                           storeId={table.storeId}
                                           staffId={table.staffId}
                                           staffName={table.staffName}
                                           fetchData={table.appointmentData}
                                           selectedDate={this.state.dateFilter}
                                           loginData={loginData}
                                           isAdmin={isAdmin}
                                           reloadTable={this.getAppointmentsByDateAndStaff}
                                           handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
                    )}
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Appointments;
